import { documentsService } from 'hq/services';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { IssueDocumentData } from 'hq/services/documents-service.types';

export const useIssueDocument = () => {
  const mutationFn = async (formData: IssueDocumentData) => {
    return await documentsService.issueDocument(formData);
  };

  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.documents());
    },
  });
};
